(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grija-chat"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('grija-chat')) {
    customElements.define('grija-chat', class extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[data-panel]');
        this.body = this.querySelector('[data-body]');
        this.chips = this.querySelector('[data-chips]');
        this.launcher = this.querySelector('[data-launcher]');
        this.nudge = this.querySelector('[data-nudge]');
        this.dot = this.querySelector('[data-dot]');
        this.avatar = this.querySelector('template[data-avatar]').innerHTML;
        this.labels = this.querySelector('template[data-labels]').dataset;
        this.answers = [...this.querySelectorAll('template[data-answer]')].map((t) => ({
          id: t.dataset.id, q: t.dataset.q, html: t.innerHTML, menu: t.dataset.menu === '1',
          action: t.dataset.action, link: t.dataset.link, linkLabel: t.dataset.linkLabel
        }));
        this.mq = window.matchMedia('(max-width: 749px)');
        this.started = false;
        this.history = [];
        this.initAi();

        this.launcher.addEventListener('click', () => (this.classList.contains('is-open') ? this.close() : this.open()));
        this.querySelector('[data-close]').addEventListener('click', () => this.close());
        this.querySelectorAll('[data-open-chat]').forEach((b) => b.addEventListener('click', () => this.open()));
        this.querySelector('[data-nudge-close]')?.addEventListener('click', () => this.dismissNudge(true));
        this.querySelector('[data-nudge-add]')?.addEventListener('click', (e) => this.addFromPage(e.currentTarget));
        this.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });

        this.watchSticky();
        this.scheduleNudge();
        document.addEventListener('shopify:section:select', (e) => { if (this.closest('.shopify-section')?.id.includes(e.detail.sectionId)) this.open(); });
      }

      store(key, val) {
        try { if (val === undefined) return sessionStorage.getItem(key); sessionStorage.setItem(key, val); } catch (e) { return null; }
      }

      scheduleNudge() {
        if (!this.nudge || !this.dataset.proactive) return;
        if (this.mq.matches && !this.dataset.proactiveMobile) return;
        if (this.store('gchNudge') === 'done') return;
        const delay = parseInt(this.dataset.delay, 10) || 4000;
        this.nudgeTimer = setTimeout(() => {
          if (this.classList.contains('is-open')) return;
          this.nudge.hidden = false;
          this.store('gchNudge', 'done');
          if (this.mq.matches) {
            const y0 = window.scrollY;
            this.onScrollHide = () => { if (Math.abs(window.scrollY - y0) > 260) this.dismissNudge(false); };
            window.addEventListener('scroll', this.onScrollHide, { passive: true });
            this.nudgeAuto = setTimeout(() => this.dismissNudge(false), 14000);
          }
        }, delay);
      }

      dismissNudge(byUser) {
        if (!this.nudge || this.nudge.hidden) return;
        this.nudge.hidden = true;
        clearTimeout(this.nudgeAuto);
        if (this.onScrollHide) window.removeEventListener('scroll', this.onScrollHide);
        if (!byUser) this.dot.hidden = false;
      }

      watchSticky() {
        const sticky = document.querySelector('[data-sticky]');
        if (!sticky) return;
        const update = () => {
          const visible = sticky.classList.contains('is-visible');
          this.style.setProperty('--gch-lift', visible ? Math.ceil(sticky.getBoundingClientRect().height) + 'px' : '0px');
        };
        new MutationObserver(update).observe(sticky, { attributes: true, attributeFilter: ['class'] });
        window.addEventListener('resize', update, { passive: true });
        update();
      }

      open() {
        clearTimeout(this.nudgeTimer);
        this.dismissNudge(true);
        this.dot.hidden = true;
        this.panel.hidden = false;
        this.classList.add('is-open');
        this.launcher.setAttribute('aria-expanded', 'true');
        if (this.mq.matches) document.documentElement.classList.add('gch-lock');
        if (!this.started) { this.started = true; this.welcome(); }
        setTimeout(() => this.querySelector('[data-close]').focus({ preventScroll: true, focusVisible: false }), 50);
      }

      close() {
        this.panel.hidden = true;
        this.classList.remove('is-open');
        this.launcher.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('gch-lock');
        this.launcher.focus({ preventScroll: true });
      }

      scrollDown() { requestAnimationFrame(() => { this.body.scrollTop = this.body.scrollHeight; }); }

      botSay(html, delay = 550) {
        return new Promise((resolve) => {
          const typing = document.createElement('div');
          typing.className = 'gch__msg';
          typing.innerHTML = this.avatar + '<div class="gch__bubble gch__typing" aria-hidden="true"><i></i><i></i><i></i></div>';
          this.body.appendChild(typing);
          this.scrollDown();
          setTimeout(() => {
            const bub = typing.querySelector('.gch__bubble');
            bub.className = 'gch__bubble';
            bub.removeAttribute('aria-hidden');
            bub.innerHTML = html;
            typing.querySelectorAll('a[href]').forEach((a) => { a.target = '_blank'; a.rel = 'noopener'; });
            this.scrollDown();
            resolve(typing);
          }, delay);
        });
      }

      meSay(text) {
        const m = document.createElement('div');
        m.className = 'gch__msg gch__msg--me';
        const b = document.createElement('div');
        b.className = 'gch__bubble';
        b.textContent = text;
        m.appendChild(b);
        this.body.appendChild(m);
        this.scrollDown();
      }

      actions(list) {
        if (!list.length) return;
        const wrap = document.createElement('div');
        wrap.className = 'gch__msg-actions';
        list.forEach((a) => wrap.appendChild(a));
        this.body.appendChild(wrap);
        this.scrollDown();
      }

      button(label, cls, onClick) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'gch__pill' + (cls ? ' ' + cls : '');
        b.textContent = label;
        b.addEventListener('click', onClick);
        return b;
      }

      link(label, href, solid) {
        const a = document.createElement('a');
        a.className = 'gch__pill' + (solid ? ' gch__pill--solid' : '');
        a.href = href;
        a.textContent = label;
        a.style.textDecoration = 'none';
        a.style.display = 'inline-flex';
        a.style.alignItems = 'center';
        return a;
      }

      initAi() {
        this.askForm = this.querySelector('[data-ask]');
        if (!this.askForm) return;
        this.input = this.askForm.querySelector('input');
        this.sendBtn = this.askForm.querySelector('button');
        this.askForm.addEventListener('submit', (e) => { e.preventDefault(); this.sendAi(); });
        this.sid = this.store('gchSid');
        if (!this.sid) { this.sid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2); this.store('gchSid', this.sid); }
      }

      remember(role, text) {
        text = String(text || '').trim();
        if (!text) return;
        this.history.push({ role, content: text.slice(0, 1200) });
        if (this.history.length > 20) this.history = this.history.slice(-20);
        while (this.history.length && this.history[0].role !== 'user') this.history.shift();
      }

      plain(html) {
        const d = document.createElement('div');
        d.innerHTML = html;
        return d.textContent.replace(/\s+/g, ' ').trim();
      }

      format(text) {
        const esc = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
        return text.trim().split(/\n{2,}/).map((p) => '<p>' + esc(p)
          .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
          .replace(/([\w.+-]+@[\w-]+\.[a-z]{2,})/gi, '<a href="mailto:$1">$1</a>')
          .replace(/\n/g, '<br>') + '</p>').join('');
      }

      async sendAi() {
        const q = this.input.value.trim();
        if (!q || this.busy) return;
        this.busy = true;
        this.sendBtn.disabled = true;
        this.input.value = '';
        this.meSay(q);
        this.remember('user', q);
        const msg = document.createElement('div');
        msg.className = 'gch__msg';
        msg.innerHTML = this.avatar + '<div class="gch__bubble gch__typing" aria-hidden="true"><i></i><i></i><i></i></div>';
        this.body.appendChild(msg);
        this.scrollDown();
        let reply = '';
        try {
          const res = await fetch(this.askForm.dataset.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ messages: this.history, sid: this.sid, page: location.pathname })
          });
          const data = await res.json();
          reply = typeof data.reply === 'string' ? data.reply : '';
        } catch (e) { reply = ''; }
        const bubble = msg.querySelector('.gch__bubble');
        bubble.className = 'gch__bubble';
        if (reply) {
          this.remember('assistant', reply);
          bubble.innerHTML = this.format(reply);
        } else {
          this.history.pop();
          bubble.innerHTML = this.format(this.askForm.dataset.aiError || this.labels.error);
        }
        this.scrollDown();
        this.busy = false;
        this.sendBtn.disabled = false;
        if (!this.mq.matches) this.input.focus({ preventScroll: true });
      }

      renderChips() {
        this.chips.innerHTML = '';
        this.answers.filter((a) => a.menu).forEach((a) => this.chips.appendChild(this.button(a.q, '', () => this.ask(a))));
      }

      async welcome() {
        const w = this.querySelector('template[data-welcome]').innerHTML.trim();
        if (w) await this.botSay(w, 400);
        this.renderChips();
      }

      async ask(a) {
        this.meSay(a.q);
        await this.botSay(a.html);
        this.remember('user', a.q);
        this.remember('assistant', this.plain(a.html));
        const acts = [];
        const L = this.labels;
        if (a.action === 'packs') {
          acts.push(this.button(L.addPrefix + ' ' + L.addThree, 'gch__pill--solid', (e) => this.add(3, e.currentTarget)));
          acts.push(this.button(L.addPrefix + ' ' + L.addSix, '', (e) => this.add(6, e.currentTarget)));
          acts.push(this.button(L.addPrefix + ' ' + L.addOne, '', (e) => this.add(1, e.currentTarget)));
        } else if (a.action === 'add_3') {
          acts.push(this.button(L.addPrefix + ' ' + L.addThree, 'gch__pill--solid', (e) => this.add(3, e.currentTarget)));
        } else if (a.action === 'link' && a.link) {
          const l = this.link(a.linkLabel || a.q, a.link, true);
          l.target = '_blank';
          l.rel = 'noopener';
          acts.push(l);
        }
        this.actions(acts);
      }

      addFromPage(btn) {
        const checked = document.querySelector('.grija-buy input[type="radio"]:checked');
        const qty = checked ? parseInt(checked.dataset.qty, 10) || 1 : 3;
        const variant = checked ? checked.value : this.dataset.variant;
        this.open();
        this.meSay(btn.textContent.trim());
        this.add(qty, null, variant);
      }

      async add(qty, btn, variantId) {
        if (btn) btn.disabled = true;
        const id = parseInt(variantId || this.dataset.variant, 10);
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        try {
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: qty }] })
          });
          if (!res.ok) throw new Error('add');
          const cart = await (await fetch(root + 'cart.js')).json();
          document.querySelectorAll('[data-cart-count], .cart-bubble__text-count').forEach((el) => { el.textContent = cart.item_count; });
          document.querySelectorAll('a[href$="/cart"] span').forEach((el) => { if (/\(\d+\)/.test(el.textContent)) el.textContent = el.textContent.replace(/\(\d+\)/, '(' + cart.item_count + ')'); });
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'grija-chat', data: { itemCount: cart.item_count, source: 'grija-chat' } } }));
          const qtyLabel = ({ 1: this.labels.addOne, 3: this.labels.addThree, 6: this.labels.addSix })[qty] || String(qty);
          const tpl = this.querySelector('template[data-added]').innerHTML.replace('[qty]', qtyLabel);
          await this.botSay(tpl, 350);
          this.actions([this.link(this.labels.toCart, this.dataset.cartUrl, true), this.button(this.labels.menu, '', () => this.renderChips())]);
        } catch (e) {
          await this.botSay('<p>' + this.labels.error + '</p>', 300);
        } finally {
          if (btn) btn.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grija-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('grija-tabs')) {
    customElements.define('grija-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, false));
          tab.addEventListener('keydown', (e) => {
            let n = null;
            if (e.key === 'ArrowRight') n = (i + 1) % this.tabs.length;
            if (e.key === 'ArrowLeft') n = (i - 1 + this.tabs.length) % this.tabs.length;
            if (e.key === 'Home') n = 0;
            if (e.key === 'End') n = this.tabs.length - 1;
            if (n !== null) { e.preventDefault(); this.select(n, true); }
          });
        });
        this.onBlock = (e) => {
          if (!this.contains(e.target)) return;
          const p = e.target.getAttribute('data-panel');
          if (p) this.select(parseInt(p, 10) - 1, false);
          if (e.target.tagName === 'DETAILS') e.target.open = true;
        };
        document.addEventListener('shopify:block:select', this.onBlock);
      }
      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlock);
      }
      select(i, focus) {
        this.tabs.forEach((t, j) => {
          const on = j === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          this.panels[j].hidden = !on;
        });
        if (focus) this.tabs[i].focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
